module.exports = __webpack_public_path__ + "media/media/about/jd-irving-89e1a20acd1d286c103c0c1e8f1458f2.png";